'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GenericComponent = require('../GenericComponent');

var _GenericComponent2 = _interopRequireDefault(_GenericComponent);

var _ForwardContainer = require('./ForwardContainer');

var _connectWithContext = require('../../connectWithContext');

var _connectWithContext2 = _interopRequireDefault(_connectWithContext);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contextTypes = {
  playerId: _propTypes2.default.string.isRequired
};

exports.default = (0, _connectWithContext2.default)(_ForwardContainer.mapStateToProps, _ForwardContainer.mapDispatchToProps, contextTypes)(_GenericComponent2.default);
module.exports = exports['default'];